/*! (c) Andrea Giammarchi @webreflection ISC */
!(function () {
  "use strict";
  var e =
      "function" == typeof Promise
        ? Promise
        : function (e) {
            var t,
              n = [],
              r = 0;
            return (
              e(function (e) {
                (t = e), (r = 1), n.splice(0).forEach(o);
              }),
              { then: o }
            );
            function o(e) {
              return r ? setTimeout(e, 0, t) : n.push(e), this;
            }
          },
    t = function (e, t) {
      var n = function (e) {
          for (var t = 0, n = e.length; t < n; t++) r(e[t]);
        },
        r = function (e) {
          var t = e.target,
            n = e.attributeName,
            r = e.oldValue;
          t.attributeChangedCallback(n, r, t.getAttribute(n));
        };
      return function (o, a) {
        var l = o.constructor.observedAttributes;
        return (
          l &&
            e(a).then(function () {
              new t(n).observe(o, {
                attributes: !0,
                attributeOldValue: !0,
                attributeFilter: l,
              });
              for (var e = 0, a = l.length; e < a; e++)
                o.hasAttribute(l[e]) &&
                  r({ target: o, attributeName: l[e], oldValue: null });
            }),
          o
        );
      };
    },
    n = !0,
    r = !1,
    o = "querySelectorAll";
  function a(e) {
    this.observe(e, { subtree: n, childList: n });
  }
  var l = "querySelectorAll",
    c = self,
    u = c.document,
    i = c.Element,
    s = c.MutationObserver,
    f = c.Set,
    h = c.WeakMap,
    d = function (e) {
      return l in e;
    },
    v = [].filter,
    g = function (e) {
      var t = new h(),
        c = function (n, r) {
          var o;
          if (r)
            for (
              var a,
                l = (function (e) {
                  return (
                    e.matches || e.webkitMatchesSelector || e.msMatchesSelector
                  );
                })(n),
                c = 0,
                u = p.length;
              c < u;
              c++
            )
              l.call(n, (a = p[c])) &&
                (t.has(n) || t.set(n, new f()),
                (o = t.get(n)).has(a) || (o.add(a), e.handle(n, r, a)));
          else
            t.has(n) &&
              ((o = t.get(n)),
              t.delete(n),
              o.forEach(function (t) {
                e.handle(n, r, t);
              }));
        },
        g = function (e) {
          for (
            var t =
                !(arguments.length > 1 && void 0 !== arguments[1]) ||
                arguments[1],
              n = 0,
              r = e.length;
            n < r;
            n++
          )
            c(e[n], t);
        },
        p = e.query,
        m = e.root || u,
        y = (function (e, t, l) {
          var c = function t(r, a, l, c, u) {
              for (var i = 0, s = r.length; i < s; i++) {
                var f = r[i];
                (u || o in f) &&
                  (c
                    ? a.has(f) || (a.add(f), l.delete(f), e(f, c))
                    : l.has(f) || (l.add(f), a.delete(f), e(f, c)),
                  u || t(f[o]("*"), a, l, c, n));
              }
            },
            u = new (l || MutationObserver)(function (e) {
              for (
                var t = new Set(), o = new Set(), a = 0, l = e.length;
                a < l;
                a++
              ) {
                var u = e[a],
                  i = u.addedNodes,
                  s = u.removedNodes;
                c(s, t, o, r, r), c(i, t, o, n, r);
              }
            });
          return (u.add = a), u.add(t || document), u;
        })(c, m, s),
        w = i.prototype.attachShadow;
      return (
        w &&
          (i.prototype.attachShadow = function (e) {
            var t = w.call(this, e);
            return y.add(t), t;
          }),
        p.length && g(m[l](p)),
        {
          drop: function (e) {
            for (var n = 0, r = e.length; n < r; n++) t.delete(e[n]);
          },
          flush: function () {
            for (var e = y.takeRecords(), t = 0, n = e.length; t < n; t++)
              g(v.call(e[t].removedNodes, d), !1),
                g(v.call(e[t].addedNodes, d), !0);
          },
          observer: y,
          parse: g,
        }
      );
    },
    p = self,
    m = p.document,
    y = p.Map,
    w = p.MutationObserver,
    b = p.Object,
    E = p.Set,
    S = p.WeakMap,
    M = p.Element,
    O = p.HTMLElement,
    N = p.Node,
    A = p.Error,
    T = p.TypeError,
    q = p.Reflect,
    C = self.Promise || e,
    P = b.defineProperty,
    D = b.keys,
    L = b.getOwnPropertyNames,
    k = b.setPrototypeOf,
    I = !self.customElements,
    H = function (e) {
      for (var t = D(e), n = [], r = t.length, o = 0; o < r; o++)
        (n[o] = e[t[o]]), delete e[t[o]];
      return function () {
        for (var o = 0; o < r; o++) e[t[o]] = n[o];
      };
    };
  if (I) {
    var _ = function () {
        var e = this.constructor;
        if (!$.has(e)) throw new T("Illegal constructor");
        var t = $.get(e);
        if (U) return B(U, t);
        var n = x.call(m, t);
        return B(k(n, e.prototype), t);
      },
      x = m.createElement,
      $ = new y(),
      R = new y(),
      V = new y(),
      W = new y(),
      j = [],
      F = g({
        query: j,
        handle: function (e, t, n) {
          var r = V.get(n);
          if (t && !r.isPrototypeOf(e)) {
            var o = H(e);
            U = k(e, r);
            try {
              new r.constructor();
            } finally {
              (U = null), o();
            }
          }
          var a = "".concat(t ? "" : "dis", "connectedCallback");
          a in r && e[a]();
        },
      }).parse,
      U = null,
      z = function (t) {
        if (!R.has(t)) {
          var n,
            r = new e(function (e) {
              n = e;
            });
          R.set(t, { $: r, _: n });
        }
        return R.get(t).$;
      },
      B = t(z, w);
    P(self, "customElements", {
      configurable: !0,
      value: {
        define: function (e, t) {
          if (W.has(e))
            throw new A(
              'the name "'.concat(
                e,
                '" has already been used with this registry'
              )
            );
          $.set(t, e),
            V.set(e, t.prototype),
            W.set(e, t),
            j.push(e),
            z(e).then(function () {
              F(m.querySelectorAll(e));
            }),
            R.get(e)._(t);
        },
        get: function (e) {
          return W.get(e);
        },
        whenDefined: z,
      },
    }),
      P((_.prototype = O.prototype), "constructor", { value: _ }),
      P(self, "HTMLElement", { configurable: !0, value: _ }),
      P(m, "createElement", {
        configurable: !0,
        value: function (e, t) {
          var n = t && t.is,
            r = n ? W.get(n) : W.get(e);
          return r ? new r() : x.call(m, e);
        },
      }),
      "isConnected" in N.prototype ||
        P(N.prototype, "isConnected", {
          configurable: !0,
          get: function () {
            return !(
              this.ownerDocument.compareDocumentPosition(this) &
              this.DOCUMENT_POSITION_DISCONNECTED
            );
          },
        });
  } else
    try {
      var G = function e() {
        return self.Reflect.construct(HTMLLIElement, [], e);
      };
      G.prototype = HTMLLIElement.prototype;
      var J = "extends-li";
      self.customElements.define("extends-li", G, { extends: "li" }),
        (I = m.createElement("li", { is: J }).outerHTML.indexOf(J) < 0);
      var K = self.customElements,
        Q = K.get,
        X = K.whenDefined;
      P(self.customElements, "whenDefined", {
        configurable: !0,
        value: function (e) {
          var t = this;
          return X.call(this, e).then(function (n) {
            return n || Q.call(t, e);
          });
        },
      });
    } catch (e) {
      I = !I;
    }
  if (I) {
    var Y = function (e) {
        var t = ae.get(e);
        ve(t.querySelectorAll(this), e.isConnected);
      },
      Z = self.customElements,
      ee = M.prototype.attachShadow,
      te = m.createElement,
      ne = Z.define,
      re = Z.get,
      oe = (
        q || {
          construct: function (e) {
            return e.call(this);
          },
        }
      ).construct,
      ae = new S(),
      le = new E(),
      ce = new y(),
      ue = new y(),
      ie = new y(),
      se = new y(),
      fe = [],
      he = [],
      de = function (e) {
        return se.get(e) || re.call(Z, e);
      },
      ve = g({
        query: he,
        handle: function (e, t, n) {
          var r = ie.get(n);
          if (t && !r.isPrototypeOf(e)) {
            var o = H(e);
            ye = k(e, r);
            try {
              new r.constructor();
            } finally {
              (ye = null), o();
            }
          }
          var a = "".concat(t ? "" : "dis", "connectedCallback");
          a in r && e[a]();
        },
      }).parse,
      ge = g({
        query: fe,
        handle: function (e, t) {
          ae.has(e) &&
            (t ? le.add(e) : le.delete(e), he.length && Y.call(he, e));
        },
      }).parse,
      pe = function (e) {
        if (!ue.has(e)) {
          var t,
            n = new C(function (e) {
              t = e;
            });
          ue.set(e, { $: n, _: t });
        }
        return ue.get(e).$;
      },
      me = t(pe, w),
      ye = null;
    L(self)
      .filter(function (e) {
        return /^HTML/.test(e);
      })
      .forEach(function (e) {
        var t = self[e];
        function n() {
          var e = this.constructor;
          if (!ce.has(e)) throw new T("Illegal constructor");
          var n = ce.get(e),
            r = n.is,
            o = n.tag;
          if (r) {
            if (ye) return me(ye, r);
            var a = te.call(m, o);
            return a.setAttribute("is", r), me(k(a, e.prototype), r);
          }
          return oe.call(this, t, [], e);
        }
        P((n.prototype = t.prototype), "constructor", { value: n }),
          P(self, e, { value: n });
      }),
      P(m, "createElement", {
        configurable: !0,
        value: function (e, t) {
          var n = t && t.is;
          if (n) {
            var r = se.get(n);
            if (r && ce.get(r).tag === e) return new r();
          }
          var o = te.call(m, e);
          return n && o.setAttribute("is", n), o;
        },
      }),
      ee &&
        (M.prototype.attachShadow = function (e) {
          var t = ee.call(this, e);
          return ae.set(this, t), t;
        }),
      P(Z, "get", { configurable: !0, value: de }),
      P(Z, "whenDefined", { configurable: !0, value: pe }),
      P(Z, "define", {
        configurable: !0,
        value: function (e, t, n) {
          if (de(e))
            throw new A(
              "'".concat(e, "' has already been defined as a custom element")
            );
          var r,
            o = n && n.extends;
          ce.set(t, o ? { is: e, tag: o } : { is: "", tag: e }),
            o
              ? ((r = "".concat(o, '[is="').concat(e, '"]')),
                ie.set(r, t.prototype),
                se.set(e, t),
                he.push(r))
              : (ne.apply(Z, arguments), fe.push((r = e))),
            pe(e).then(function () {
              o
                ? (ve(m.querySelectorAll(r)), le.forEach(Y, [r]))
                : ge(m.querySelectorAll(r));
            }),
            ue.get(e)._(t);
        },
      });
  }
})();
